module.exports = __webpack_public_path__ + "img/cateicon3.da9b3924.svg";